import { lazy } from 'react'

// Lazy load all Kubernetes components for optimal code splitting
const ClusterRoleBindingsListPage = lazy(
  () => import('k8s/components/access-control/cluster-role-bindings/ClusterRoleBindingsListPage'),
)
const ClusterRolesListPage = lazy(
  () => import('k8s/components/access-control/cluster-roles/ClusterRolesListPage'),
)
const RoleBindingsListPage = lazy(
  () => import('k8s/components/access-control/role-bindings/RoleBindingsListPage'),
)
const RolesListPage = lazy(() => import('k8s/components/access-control/roles/RolesListPage'))
const ClusterNodesListPage = lazy(
  () => import('k8s/components/clusters-dashboard/ClusterNodesListPage'),
)
const ClustersDashboardPage = lazy(
  () => import('k8s/components/clusters-dashboard/ClustersDashboardPage'),
)
const ClustersUpgradePage = lazy(
  () => import('k8s/components/clusters-dashboard/ClustersUpgradePage'),
)
const ClusterDetailTabs = lazy(() => import('k8s/components/dashboard/ClusterDetailTabs'))
const ClusterDetails = lazy(() => import('k8s/components/dashboard/ClusterDetails'))
const AddBYOHHosts = lazy(() => import('k8s/components/nodes/byoh/AddBYOHHosts'))
const PhysicalHostsListPage = lazy(() => import('k8s/components/nodes/byoh/PhysicalHostsListPage'))
const ConfigMapsListPage = lazy(
  () => import('k8s/components/resources/config-maps/ConfigMapsListPage'),
)
const ConfigMapsDetailsPage = lazy(
  () => import('k8s/components/resources/config-maps/details/ConfigMapsDetailsPage'),
)
const CustomResourceDefinitionsListPage = lazy(
  () =>
    import(
      'k8s/components/resources/custom-resource-definitions/CustomResourceDefinitionsListPage'
    ),
)
const CustomResourceDefinitionsDetailsPage = lazy(
  () =>
    import(
      'k8s/components/resources/custom-resource-definitions/details/CustomResourceDefinitionsDetailsPage'
    ),
)
const CustomResourceDetailsPage = lazy(
  () =>
    import(
      'k8s/components/resources/custom-resource-definitions/details/custom-resources/CustomResourceDetailsPage'
    ),
)
const NamespacesListPage = lazy(
  () => import('k8s/components/resources/namespaces/NamespacesListPage'),
)
const PersistentVolumeClaimsListPage = lazy(
  () => import('k8s/components/resources/persistent-volume-claims/PersistentVolumeClaimsListPage'),
)
const PersistentVolumeClaimDetailsPage = lazy(
  () =>
    import(
      'k8s/components/resources/persistent-volume-claims/details/PersistentVolumeClaimDetailsPage'
    ),
)
const PersistentVolumesListPage = lazy(
  () => import('k8s/components/resources/persistent-volume/PersistentVolumesListPage'),
)
const PersistentVolumeDetailsPage = lazy(
  () => import('k8s/components/resources/persistent-volume/details/PersistentVolumeDetailsPage'),
)
const SecretsListPage = lazy(() => import('k8s/components/resources/secrets/SecretsListPage'))
const SecretsDetailsPage = lazy(
  () => import('k8s/components/resources/secrets/details/SecretsDetailsPage'),
)

export const kubernetesRoutesMapping = [
  {
    name: 'Kubernetes',
    link: { path: '/kubernetes/infrastructure/clusters', exact: true, default: true },
    component: ClustersDashboardPage,
  },
  {
    name: 'Infrastructure: Clusters Nodes',
    link: { path: '/kubernetes/infrastructure/clusters-nodes/:tab?', exact: true },
    component: ClusterNodesListPage,
  },
  {
    name: 'Infrastructure: Clusters Nodes: Add Physical Hosts',
    link: {
      path: '/kubernetes/infrastructure/clusters-nodes/:tab/add-physical-hosts',
      exact: true,
    },
    component: AddBYOHHosts,
  },
  {
    name: 'Infrastructure: Physical Nodes',
    link: { path: '/kubernetes/infrastructure/physical-hosts', exact: true },
    component: PhysicalHostsListPage,
  },
  {
    name: 'Infrastructure: Physical Nodes: Add Physical Hosts',
    link: { path: '/kubernetes/infrastructure/physical-hosts/add-physical-hosts', exact: true },
    component: PhysicalHostsListPage,
  },
  {
    name: 'Infrastructure: Upgrade',
    link: { path: '/kubernetes/infrastructure/clusters/:cluster/upgrade', exact: true },
    component: ClustersUpgradePage,
  },
  {
    name: 'Infrastructure: Upgrade Status Modal',
    link: { path: 'kubernetes/infrastructure/clusters/:cluster/upgrade-status', exact: true },
    component: ClusterDetails,
  },
  {
    name: 'Infrastructure: Cluster Overview',
    link: {
      path: '/kubernetes/infrastructure/clusters/:cluster/:tab?',
      exact: true,
    },
    component: ClusterDetailTabs,
  },
  {
    name: 'Roles',
    link: {
      path: '/clusters/:cluster/access-control/roles',
      exact: true,
    },
    component: RolesListPage,
  },
  {
    name: 'Add Roles',
    link: {
      path: '/clusters/:cluster/access-control/roles/add',
      exact: true,
    },
    component: RolesListPage,
  },
  {
    name: 'Edit Roles',
    link: {
      path: '/clusters/:cluster/access-control/roles/:roleId/edit',
      exact: true,
    },
    component: RolesListPage,
  },
  {
    name: 'Role Bindings',
    link: {
      path: '/clusters/:cluster/access-control/role-bindings',
      exact: true,
    },
    component: RoleBindingsListPage,
  },
  {
    name: 'Add Role Bindings',
    link: {
      path: '/clusters/:cluster/access-control/role-bindings/add',
      exact: true,
    },
    component: RoleBindingsListPage,
  },
  {
    name: 'Edit Role Bindings',
    link: {
      path: '/clusters/:cluster/access-control/role-bindings/:id/edit',
      exact: true,
    },
    component: RoleBindingsListPage,
  },
  {
    name: 'Cluster Roles',
    link: {
      path: '/clusters/:cluster/access-control/cluster-roles',
      exact: true,
    },
    component: ClusterRolesListPage,
  },
  {
    name: 'Add Cluster Roles',
    link: {
      path: '/clusters/:cluster/access-control/cluster-roles/add',
      exact: true,
    },
    component: ClusterRolesListPage,
  },
  {
    name: 'Edit Cluster Roles',
    link: {
      path: '/clusters/:cluster/access-control/cluster-roles/:id/edit',
      exact: true,
    },
    component: ClusterRolesListPage,
  },
  {
    name: 'Cluster Role Bindings',
    link: {
      path: '/clusters/:cluster/access-control/cluster-role-bindings',
      exact: true,
    },
    component: ClusterRoleBindingsListPage,
  },
  {
    name: 'Add Cluster Role Bindings',
    link: {
      path: '/clusters/:cluster/access-control/cluster-role-bindings/add',
      exact: true,
    },
    component: ClusterRoleBindingsListPage,
  },
  {
    name: 'Edit Cluster Role Bindings',
    link: {
      path: '/clusters/:cluster/access-control/cluster-role-bindings/:id/edit',
      exact: true,
    },
    component: ClusterRoleBindingsListPage,
  },
  {
    name: 'Namespaces',
    link: {
      path: '/clusters/:cluster/resources/namespaces',
      exact: true,
    },
    component: NamespacesListPage,
  },
  {
    name: 'Add Namespaces',
    link: {
      path: '/clusters/:cluster/resources/namespaces/add',
      exact: true,
    },
    component: NamespacesListPage,
  },
  {
    name: 'Config Maps',
    link: {
      path: '/clusters/:cluster/resources/config-maps',
      exact: true,
    },
    component: ConfigMapsListPage,
  },
  {
    name: 'Add Config Maps',
    link: {
      path: '/clusters/:cluster/resources/config-maps/add',
      exact: true,
    },
    component: ConfigMapsListPage,
  },
  {
    name: 'Config Maps Details',
    link: {
      path: '/clusters/:cluster/resources/config-maps/:id/:tab?',
      exact: true,
    },
    component: ConfigMapsDetailsPage,
  },
  {
    name: 'Secrets',
    link: {
      path: '/clusters/:cluster/resources/secrets',
      exact: true,
    },
    component: SecretsListPage,
  },
  {
    name: 'Add Secrets',
    link: {
      path: '/clusters/:cluster/resources/secrets/add',
      exact: true,
    },
    component: SecretsListPage,
  },
  {
    name: 'Secrets Details',
    link: {
      path: '/clusters/:cluster/resources/secrets/:id/:tab?',
      exact: true,
    },
    component: SecretsDetailsPage,
  },
  {
    name: 'Custom Resource Definitions',
    link: { path: '/clusters/:cluster/resources/custom-resource-definitions/(add)?', exact: true },
    component: CustomResourceDefinitionsListPage,
  },
  {
    name: 'Custom Resource Definitions Details',
    link: {
      path: '/clusters/:cluster/resources/custom-resource-definitions/:id/:tab/(add)?',
      exact: true,
    },
    component: CustomResourceDefinitionsDetailsPage,
  },
  {
    name: 'Custom Resource Details',
    link: {
      path: '/clusters/:cluster/resources/custom-resource-definitions/:id/custom-resources/:name/:tab?',
      exact: true,
    },
    component: CustomResourceDetailsPage,
  },
  {
    name: 'Persistant Volume Claims',
    link: {
      path: '/clusters/:cluster/resources/persistent-volume-claims/(add)?',
      exact: true,
    },
    component: PersistentVolumeClaimsListPage,
  },
  {
    name: 'Persistent Volume Claim Details',
    link: { path: '/clusters/:cluster/resources/persistent-volume-claims/:id/:tab?', exact: true },
    component: PersistentVolumeClaimDetailsPage,
  },
  {
    name: 'Persistent Volumes',
    link: {
      path: '/clusters/:cluster/resources/persistent-volumes',
      exact: true,
    },
    component: PersistentVolumesListPage,
  },
  {
    name: 'Add Persistent Volumes',
    link: {
      path: '/clusters/:cluster/resources/persistent-volumes/add',
      exact: true,
    },
    component: PersistentVolumesListPage,
  },
  {
    name: 'Persistent Volumes Details',
    link: {
      path: '/clusters/:cluster/resources/persistent-volumes/:id/:tab?',
      exact: true,
    },
    component: PersistentVolumeDetailsPage,
  },
]

export const kubernetesNav = {
  requiredFeatures: (features) => features?.kaapi?.enable_kaapi !== false,
  name: 'Kubernetes',
  link: { path: '/kubernetes/infrastructure/clusters' },
  icon: 'kubernetes',
  nestedLinks: [
    {
      name: 'Infrastructure',
      link: { path: '/kubernetes/infrastructure/clusters' },
      nestedLinks: [
        { name: 'Clusters', link: { path: '/kubernetes/infrastructure/clusters' } },
        {
          name: 'Clusters Nodes',
          link: {
            path: '/kubernetes/infrastructure/clusters-nodes/virtualized-nodes',
            definition: '/kubernetes/infrastructure/clusters-nodes/:tab',
          },
        },
        {
          name: 'Physical Hosts',
          link: {
            path: '/kubernetes/infrastructure/physical-hosts',
            definition: '/kubernetes/infrastructure/physical-hosts',
          },
        },
      ],
    },
    {
      name: 'Access Control',
      isk8sNav: true,
      link: {
        path: '/clusters/:cluster/access-control/roles',
        definition: '/clusters/:cluster/access-control/roles',
      },
      // icon: 'user-shield',
      nestedLinks: [
        {
          name: 'Roles',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/access-control/roles',
            definition: '/clusters/:cluster/access-control/roles',
          },
        },
        {
          name: 'Role Bindings',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/access-control/role-bindings',
            definition: '/clusters/:cluster/access-control/role-bindings',
          },
        },
        {
          name: 'Cluster Roles',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/access-control/cluster-roles',
            definition: '/clusters/:cluster/access-control/cluster-roles',
          },
        },
        {
          name: 'Cluster Role Bindings',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/access-control/cluster-role-bindings',
            definition: '/clusters/:cluster/access-control/cluster-role-bindings',
          },
        },
      ],
    },
    {
      name: 'Resources',
      isk8sNav: true,
      link: {
        path: '/clusters/:cluster/resources/namespaces',
        definition: '/clusters/:cluster/resources/namespaces',
      },
      nestedLinks: [
        {
          name: 'Namespaces',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/resources/namespaces',
            definition: '/clusters/:cluster/resources/namespaces',
          },
        },
        {
          name: 'Config Maps',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/resources/config-maps',
            definition: '/clusters/:cluster/resources/config-maps',
          },
        },
        {
          name: 'Secrets',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/resources/secrets',
            definition: '/clusters/:cluster/resources/secrets',
          },
        },
        {
          name: 'Custom Resource Definitions',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/resources/custom-resource-definitions',
            definition: '/clusters/:cluster/resources/custom-resource-definitions',
          },
        },
        {
          name: 'Persistent Volume Claims',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/resources/persistent-volume-claims',
            definition: '/clusters/:cluster/resources/persistent-volume-claims',
          },
        },

        {
          name: 'Persistent Volumes',
          isk8sNav: true,
          link: {
            path: '/clusters/:cluster/resources/persistent-volumes',
            definition: '/clusters/:cluster/resources/persistent-volumes',
          },
        },
      ],
    },
  ],
}
